import { Component, AfterContentInit, contentChildren, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Tab} from './tab/tab';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.html',
  styleUrls: ['./tabs.css']
})
export class Tabs implements AfterContentInit {
  tabs = contentChildren(Tab);

  initialTab = input<string>('');
  tabChange = output<Tab>();

  activeIndex = signal(0);
  previousIndex = signal(0);

  ngAfterContentInit() {
    let initialIndex = 0;

    if (this.initialTab()) {
      const foundIndex = this.tabs().findIndex(tab => tab.key() === this.initialTab());
      if (foundIndex !== -1) {
        initialIndex = foundIndex;
      }
    }

    this.activeIndex.set(initialIndex);
    this.previousIndex.set(initialIndex);

    this.tabs().forEach((tab, i) => {
      tab.isActive.set(i === initialIndex);
      if (i === initialIndex) {
        tab.hasBeenViewed.set(true);
      }
    });
  }

  selectTab(index: number) {
    const tab = this.tabs()[index];

    if (tab && !tab.disabled() && index !== this.activeIndex()) {
      const direction = index > this.activeIndex() ? 'left' : 'right';

      // Update all tabs
      this.tabs().forEach((t, i) => {
        t.isActive.set(i === index);
        if (i === index) {
          t.slideDirection.set(direction);
          t.hasBeenViewed.set(true); // Mark as viewed when activated
        }
      });

      this.previousIndex.set(this.activeIndex());
      this.activeIndex.set(index);
      this.tabChange.emit(tab);
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex() === index;
  }
}
